import { sagas as insuranceSagas } from './modules/insurancePolicies'

export default [...insuranceSagas]
